import { Result } from 'domain/types';
import ReadWidgetDataClient from 'use-case/widgets/data/read/readWidgetDataClient';
import ReadWidgetDataCriteria from 'use-case/widgets/data/read/readWidgetDataCriteria';
import { WidgetDataTypes } from 'domain/entity/widgetData';

export type ReadWidgetDataResult = Result<WidgetDataTypes>;
export type ReadWidgetData = (criteria: ReadWidgetDataCriteria) => Promise<ReadWidgetDataResult>;

export default (readWidgetClient: ReadWidgetDataClient): ReadWidgetData => (
    criteria: ReadWidgetDataCriteria
): Promise<ReadWidgetDataResult> => readWidgetClient(criteria);
